const DATE_TIME_FORMATTER = new Intl.DateTimeFormat('es-PA', {
  weekday: 'short',
  day: 'numeric',
  month: 'short',
  hour: 'numeric',
  minute: '2-digit',
});

/** Hour and minute only, for the Cobrado post-action state (FLOWS.md §1: "hora", not the full date). */
const TIME_FORMATTER = new Intl.DateTimeFormat('es-PA', { hour: 'numeric', minute: '2-digit' });

/**
 * Panama prices in dollars the way the street writes them: $15.00. The es-PA
 * currency formatter spells out "USD 15.00" (to disambiguate from the balboa),
 * which is technically right and reads wrong at a counter; both currencies are
 * dollar-pegged, so the plain sign is the honest local form.
 */
const MONEY_NUMBER_FORMATTER = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatDateTime(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return DATE_TIME_FORMATTER.format(date);
}

export function formatMoneyCents(cents: number): string {
  const sign = cents < 0 ? '−' : '';
  return `${sign}$${MONEY_NUMBER_FORMATTER.format(Math.abs(cents) / 100)}`;
}

/** Like formatMoneyCents, but a round amount drops its «.00»: «$1,750» and «$12.50». */
export function formatMoneyShort(cents: number): string {
  const full = formatMoneyCents(cents);
  return cents % 100 === 0 ? full.replace(/\.00$/, '') : full;
}

const DATE_ONLY_FORMATTER = new Intl.DateTimeFormat('es-PA', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});

/** 'YYYY-MM-DD' as a calendar date ('1 ene. 2026'), never shifted by timezone. */
export function formatDateOnly(ymd: string): string {
  const [year, month, day] = ymd.split('-').map(Number);
  if (!year || !month || !day) return ymd;
  return DATE_ONLY_FORMATTER.format(new Date(year, month - 1, day));
}

export function formatTime(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return TIME_FORMATTER.format(date);
}

export function isSameDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}
